<template>
  <modal-form :class="$style.dialog" @cancel="$formCancelHandler" @submit="$formSubmitHandler">
    <span slot="header">Change Personal Information</span>

    <div slot="body" class="vModalDefaultBody personal-info">
      <div :class="$style.columnsContainer">
        <rb-input for-id="firstName" :error="$showError('firstName')" :class="$style.column">
          <span slot="label">First Name</span>
          <input
            id="firstName"
            v-model="data.firstName"
            v-validate="{required: true, max: 50}"
            type="text"
            name="firstName"
            class="rbInput"
            autofocus
            data-vv-as="First Name"
          >
        </rb-input>

        <rb-input for-id="lastName" :error="$showError('lastName')" :class="$style.column">
          <span slot="label">Last Name</span>
          <input
            id="lastName"
            v-model="data.lastName"
            v-validate="{required: true, max: 50}"
            type="text"
            name="lastName"
            class="rbInput"
            data-vv-as="Last Name"
          >
        </rb-input>
      </div>

      <rb-input for-id="phone" :error="$showError('phone')">
        <span slot="label">Phone</span>
        <input
          id="phone"
          v-model="data.phone"
          v-validate="{ max:20, regex: /^(\+|00)?[(]?[0-9]{0,3}[)]?[-\s.]?[[0-9]{0,3}]?[-\s./]?[[0-9]{0,3}]?[-\s.]?[0-9]{3,7}$/ }"
          type="text"
          name="phone"
          class="rbInput"
          data-vv-as="Phone Number"
        >
      </rb-input>
    </div>
  </modal-form>
</template>

<script>
  import ModalForm from 'vRoot/_core/RbModalForm.vue'
  import DialogMixin from 'vRoot/_mixins/DialogMixin.vue'
  import RbFormMixin from 'vRoot/_mixins/RbFormMixin.vue'
  import RbInput from 'vRoot/_core/RbInput.vue'

  export default {
    name: 'RbvUserProfileEditPersonalInfoDialog',
    components: { RbInput, ModalForm },
    mixins: [ RbFormMixin, DialogMixin ],
    props: {
      user: {
        type: Object,
        required: true,
      }
    },
    data() {
      return {
        data: {}
      }
    },
    mounted () {
      this.data = {
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        phone: this.user.phone
      }
    },
    methods: {
      onSubmit () { return {form: this.data} }
    }
  }
</script>

<style lang="stylus" module="">

  .dialog {
    min-width 400px
  }


  .columnsContainer {
    display flex
    justify-content space-between
  }

  .column {
    width: 49%
  }

</style>
